import Raect, { useRef, useState } from "react";
import AboveTheFold from "./AboveTheFold";
import Article from "./Article";
import Suggestions from "./Suggestions";

function BlogPage() {
  const scrollCount = useRef(0);
  const [hideScroller, setHideScroller] = useState(false);
  const hideScroll = (event) => {
    if (scrollCount.current == 0) {
      scrollCount.current += 1;
      setHideScroller(true);
      console.log(scrollCount.current);
    }
  };
  return (
    <div onScroll={hideScroll} className="custom-blog-page">
      <AboveTheFold hideScroller={hideScroller}></AboveTheFold>
      <Article></Article>
      <div className="custom-article-end">
        <div className="bullet"></div>
        <div className="bullet"></div>
        <div className="bullet"></div>
        <div className="bullet"></div>
      </div>
      <Suggestions></Suggestions>
      <h1>ss</h1>
    </div>
  );
}

export default BlogPage;
